export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Ошибка инициализации",
    "StaticConfigLoader.caption.init": "Инициализация",
    "StaticConfigLoader.text.init": "Инициализация приложения...",
    "StaticConfigLoader.error.settings": "Не удалось загрузить настройки приложения",
    "StaticConfigLoader.error.circuits": "Не удалось загрузить настройки контура",
    //app
    "Legal.Localization": "ru",
    "AchievementApp.Navbar.storeTitle": "Магазин",
    "AchievementApp.Navbar.supportTitle": "Помощь",
    "Legal.TermsConditions": "Условия использования",
    "Legal.TermsService": "Условия предоставления сервисов",
    "Legal.PrivacyPolicy": "Политика конфиденциальности",
    "Legal.CookiesPolicy": "Настройки Cookie",
    "Legal.Copyright": "Все товарные знаки, наименования и логотипы принадлежат их соответствующим правообладателям.",
    "AchievementApp.Navbar.achievement": "Личные достижения",
    "AchievementApp.Navbar.userAchievement": "Достижения игрока",
    "AchievementApp.Navbar.settingsLink": "Настройки",
    "AchievementApp.Navbar.profileLink": "Профиль",
    "AchievementApp.Navbar.reloginLink": "Сменить аккаунт",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net Достижения",
    //commonAssets
    "ViewItemDetailed.state.completed": "Выполнено",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Фильтр по играм",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Мои друзья",
    "UserFriendsList.heading.showMore": "Показать больше",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Необходимо настроить двухэтапную авторизацию",
    "LimitedAccountPanel.2step.link": "Подробнее о двухэтапной авторизации",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/ru/articles/203623622-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B8-%D0%BE%D1%82%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D1%8C-%D0%B4%D0%B2%D1%83%D1%85%D1%8D%D1%82%D0%B0%D0%BF%D0%BD%D1%83%D1%8E-%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D1%8E-Google-Authenticator-%D0%BF%D1%80%D0%B8%D0%B2%D1%8F%D0%B7%D0%BA%D0%B0-%D0%BA-%D1%82%D0%B5%D0%BB%D0%B5%D1%84%D0%BE%D0%BD%D1%83",
    "LimitedAccountPanel.email.reason": "Необходимо подтвердить ваш email",
    "LimitedAccountPanel.email.link": "Перейти к вашему профилю",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "На аккаунт действуют ограничения по причине:",
    "LimitedAccountPanel.conclusion": "После изменения настроек безопасности необходимо полностью выйти из аккаунта и войти снова чтобы изменения вступили в силу",
    "LimitedAccountPanel.relogin": "Сменить аккаунт",
    "EmailVerificationStateIcon.success": "Подтвержденый аккаунт",
    "EmailVerificationStateIcon.warning": "Ограниченый аккаунт, не подтверждена почта",
    "EmailVerificationStateIcon.danger": "Ограниченый аккаунт, НЕОБХОДИМО подтвердить почту",
    "TwoFactorStateIcon.success": "Аккаунт защищен двухэтапной авторизацией",
    "TwoFactorStateIcon.warning": "Ограниченый аккаунт, нет двухэтапной авторизации",
    "TwoFactorStateIcon.danger": "Ограниченый аккаунт, НЕОБХОДИМА двухэтапная авторизация",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Сохранить настройки",
    "UserSettingDialog.settings": "Настройки",
    "UserSettingDialog.userSettings": "Пользовательские настройки",
    "UserSettingDialog.language": "Язык",
    "UserSettingDialog.privacy": "Приватность",
    "UserSettingDialog.allUsers": "Все пользователи",
    "UserSettingDialog.friendsOnly": "Только друзья",
    "UserSettingDialog.onlyMe": "Только я",
    "UserSettingDialog.whoCanView": "Кто видит мои достижения",
    //unlockProgress
    "ViewUnlockProgress.of": " из ",
    "ViewUnlockProgress.achievCompleted": " достижений выполнено",
    "ViewUnlockProgress.myUnlock": "Мои достижения",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Введите ник",
    "ViewItemSearch.label.search": "Поиск пользователя",
    "ViewItemSearch.resultNotFound": "Пользователь не найден",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Достижения",
    "ViewItemSearch.stub.empty": "Достижений нет",
    "ViewItemSearch.stub.emptyCompare_1": "У игрока ",
    "ViewItemSearch.stub.emptyCompare_2": " нет достижений в этой игре",
    "ViewItemSearch.limitedAccess": "Доступ к достижениям выбранного пользователя ограничен",
    "ViewItemSearch.heading.selectGame": "Выберите игру из списка",
    "ViewItemSearch.globalstat.opened": "открыто у ",
    "ViewItemSearch.globalstat.ofGamers": "% игроков",
    //authentication
    "NotAllowedMessage.caption": "Нет доступа",
    "NotAllowedMessage.body.h1": "Доступ к достижениям",
    "NotAllowedMessage.body.h3": "закрыт для вашего аккаунта",
    "NotAllowedMessage.relogin": "Сменить аккаунт",
    "LandingMessage.caption": "Аутентификация",
    "LandingMessage.body": "Финальные проверки...",
    "TokenExpiredMessage.caption": "Аутентификация истекла",
    "TokenExpiredMessage.body.h3": "Для продолжения необходимо повторно авторизоваться",
    "TokenExpiredMessage.relogin": "Авторизоваться",
    "AuthErrorMessage.caption": "Не удалось аутентифицироваться",
    "AuthErrorMessage.body.h1": "Не удалось аутентифицироваться",
    "AuthErrorMessage.body.code": "Код ошибки",
    "AuthErrorMessage.body.desc": "Вы можете попробовать переавторизоваться",
    "AuthErrorMessage.relogin": "Авторизоваться",
    "AuthorizationRequiredMessage.caption": "Требуется аутентификация",
    "AuthorizationRequiredMessage.body.h3.1": "Для входа в аккаунт",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "требуется авторизация",
    "AuthorizationRequiredMessage.login": "Авторизоваться на Gaijin.Net",
    "CheckingAuthMessage.caption": "Аутентификация",
    "CheckingAuthMessage.body": "Аутентификация, пожалуйста подождите...",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Мобильная версия временно недоступна",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Пожалуйста, используйте компьютерную версию",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Приносим Вам свои извинения",
}